import { render, staticRenderFns } from "./AnimatedSvg.vue?vue&type=template&id=479ae72c&scoped=true&"
import script from "./AnimatedSvg.vue?vue&type=script&lang=js&"
export * from "./AnimatedSvg.vue?vue&type=script&lang=js&"
import style0 from "./AnimatedSvg.vue?vue&type=style&index=0&id=479ae72c&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "479ae72c",
  null
  
)

export default component.exports